/**
 * SQ Product Card Ratings — JS-rendered ★ avg · count markup.
 *
 * Waits for Judge.me to populate data-average-rating / data-number-of-reviews,
 * then renders deterministic <span> elements into [data-sq-rating].
 * Kit cards compute a weighted aggregate across kit + child product badges.
 */
(function () {
  'use strict';

  var containers = document.querySelectorAll('.sq-product-card__reviews');
  if (!containers.length) return;

  for (var i = 0; i < containers.length; i++) {
    var c = containers[i];
    if (c.hasAttribute('data-kit-aggregate')) {
      processKitCard(c);
    } else {
      processSingleCard(c);
    }
  }

  function processSingleCard(container) {
    waitForBadges(container, function () {
      var badge = container.querySelector('.jdgm-prev-badge');
      if (!badge) return;
      var count = parseInt(badge.getAttribute('data-number-of-reviews') || '0', 10);
      var rating = parseFloat(badge.getAttribute('data-average-rating') || '0');
      if (count > 0) {
        renderRating(container, rating, count);
      }
    }, 0);
  }

  function processKitCard(container) {
    waitForBadges(container, function () {
      var result = computeAggregate(container);
      if (result.totalCount > 0) {
        applyAggregate(container, result.avgRating, result.totalCount);
        renderRating(container, result.avgRating, result.totalCount);
        watchBadge(container, result.avgRating, result.totalCount);
      }
    }, 0);
  }

  function waitForBadges(container, callback, attempts) {
    var badges = container.querySelectorAll('.jdgm-prev-badge');

    if (badges.length === 0) return;

    var ready = 0;
    for (var i = 0; i < badges.length; i++) {
      if (badges[i].hasAttribute('data-number-of-reviews')) ready++;
    }

    if (ready === badges.length || attempts > 50) {
      callback();
      return;
    }

    setTimeout(function () { waitForBadges(container, callback, attempts + 1); }, 250);
  }

  function computeAggregate(container) {
    var badges = container.querySelectorAll('.jdgm-prev-badge');
    var totalCount = 0;
    var weightedSum = 0;

    for (var i = 0; i < badges.length; i++) {
      var count = parseInt(badges[i].getAttribute('data-number-of-reviews') || '0', 10);
      var rating = parseFloat(badges[i].getAttribute('data-average-rating') || '0');
      if (count > 0) {
        totalCount += count;
        weightedSum += rating * count;
      }
    }

    return {
      avgRating: totalCount > 0 ? weightedSum / totalCount : 0,
      totalCount: totalCount
    };
  }

  function applyAggregate(container, avgRating, totalCount) {
    var visibleBadge = container.querySelector('.jdgm-prev-badge');
    if (!visibleBadge) return;

    visibleBadge.dataset.averageRating = avgRating.toFixed(2);
    visibleBadge.dataset.numberOfReviews = String(totalCount);
  }

  function renderRating(container, avgRating, totalCount) {
    var el = container.querySelector('[data-sq-rating]');
    if (!el) return;

    var ratingStr = avgRating.toFixed(2).replace('.', ',');
    el.innerHTML =
      '<span class="sq-rating__star">★</span>' +
      '<span class="sq-rating__avg">' + ratingStr + '</span>' +
      '<span class="sq-rating__count">· (' + totalCount + ')</span>';
  }

  function watchBadge(container, avgRating, totalCount) {
    var visibleBadge = container.querySelector('.jdgm-prev-badge');
    if (!visibleBadge) return;

    var expectedRating = avgRating.toFixed(2);
    var expectedCount = String(totalCount);

    var observer = new MutationObserver(function () {
      if (visibleBadge.dataset.averageRating === expectedRating &&
          visibleBadge.dataset.numberOfReviews === expectedCount) return;
      observer.disconnect();
      applyAggregate(container, avgRating, totalCount);
      renderRating(container, avgRating, totalCount);
      observer.observe(visibleBadge, { attributes: true, childList: true, subtree: true });
    });
    observer.observe(visibleBadge, { attributes: true, childList: true, subtree: true });
  }
})();
